module.exports = __webpack_public_path__ + "static/media/400151_02.5ab4f241.png";